import { ACCESS_ADMIN_TOKEN_KEY, ACCESS_TOKEN_KEY } from '../../contants/config';

/**
 * Opening a factsheet fails in two ways that need different answers. The session is gone
 * — no token left (logged out in another tab: 401) or the user no longer exists (404
 * "Invalid User!") — and only a fresh login helps. Anything else (network, 5xx) may pass
 * on reload. http.ts throws `{ msg }` for both.
 */
export function isSessionGoneError(e: unknown): boolean {
  const msg = (e as { msg?: string } | null)?.msg;
  return msg === 'Unauthorized' || msg === 'Invalid User!';
}

/** Same as the sidebar logout: both tokens, so "login as" cannot linger either. */
export function clearSessionTokens(): void {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(ACCESS_ADMIN_TOKEN_KEY);
}

export function loadErrorMessage(e: unknown): string {
  const err = e as { msg?: string; message?: string } | null;
  return err?.msg || err?.message || 'Unbekannter Fehler';
}
